import { render } from "./NavMessage.vue?vue&type=template&id=2c4dd2ce"
import script from "./NavMessage.vue?vue&type=script&lang=js"
export * from "./NavMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__